/*
 * @Description: 
 * @Author: huangshiwen
 * @Date: 2022-06-13 09:02:04
 * @LastEditTime: 2022-06-29 11:28:14
 */
import { getScreenSize } from '@/utils/index'
import { mapGetters } from 'vuex'
export default {
  data(){
    return {
      ROUTE_BASE:'',
      BASE_URL: "",
      VUE_BASE_URL: "",
    }
  },
  computed: mapGetters({
    SCREEN: 'getScreen',
    HOSPITAL: 'getHospital',
  }),
  created() {
    this.ROUTE_BASE = process.env.VUE_APP_ROUTE_BASE
    this.BASE_URL = process.env.VUE_APP_BASE_URL
    this.VUE_BASE_URL = process.env.VUE_APP_VUE_BASE_URL
  },
  methods:{
    setParentScroll(top){
      window.parent.postMessage(
        {
          type: 'setScrollTop',
          top
        },
        '*'
      )
    }
  }
}